import React from 'react'
import Listagem from './Listagem';
import { IconSearch, SearchAdd, SearchUser } from '~misc/icons';
import { Link } from 'react-router-dom';
import useModalSimulators from '~components/Modal/hooks/useModalSimulators';
import ModalSimulators from '~components/Modal/ModalSimulators';
import useSimulacoes from '~/fetchs/useSimulacoes';
import useUsuario from '~fetchs/useUsuario';

const AreaListagem = () => {
  const { usuario } = useUsuario();
  const acessoSimuladorConcreto = usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const viteMode = import.meta.env.VITE_MODE;
  const simuladoresLink = viteMode === "dev" ? "qa" : viteMode === "prod" ? "" : viteMode;
  const verPropostasLink = `https://comercial${simuladoresLink ? `-${simuladoresLink}` : ""}.vcimentos.com/#/imo/clientes`;

  const { loading, simulacoes, filters, setFilters, total } = useSimulacoes({ type: 'all', groupClient: true });
  const { isModalOpenSimulators, closeModalSimulators, openModalSimulators } = useModalSimulators()
  const handleInputChange = (e) => {
    setFilters({
      ...filters,
      busca: e.target.value,
    });
  };


  const handleSimulators = () => {
    openModalSimulators()
  }

  return (
    <>
      <div className='space-x-4 container py-5'>
        <div className='flex gap-x-2 mb-4'>
          <div className='grow relative flex items-center'>
            <label className="absolute top-[28%] left-[10px] z-10 w-[23px] h-[23px]" >
              <SearchUser />
            </label>
            <input className="input-search w-full py-5 px-10 rounded-lg  border border-solid border-gray-300  placeholder-primaria text-16" type="text" placeholder="Buscar por quaisquer campos exibidos" value={filters.busca} onChange={handleInputChange} />
            <button className="absolute top-50 right-0 p-4 z-2">
              <IconSearch />
            </button>
          </div>
          {acessoSimuladorConcreto && (
            <Link to={verPropostasLink} target="_blank" className='button-search flex py-5 px-8 bg-pendente text-white rounded-lg gap-1 font-bold text-lg' >
              Simulador de Concreto
            </Link>
          )}
          <Link>
            <button className='button-search flex py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg' onClick={handleSimulators} >
              Nova Simulação
              <SearchAdd />
            </button>
          </Link>
        </div>
      </div>

      <Listagem simulacoes={simulacoes} filter={filters} total={total} loading={loading} />

      <ModalSimulators isOpen={isModalOpenSimulators} onClose={closeModalSimulators} />
    </>
  )
}

export default AreaListagem